import { createContext } from 'react'

export const LocaleContext = createContext<'de' | 'fr' | 'en'>('de')
